// we have to insert the script on every page visit, because podlove autodestroys it
up.compiler('.js-podlove_subscribe_button', function (element, config) {
  const playerDataEl = document.querySelector(
    `.js-podlove_subscribe_button_player_data[data-player-id=${config.player_id}]`
  )
  const playerData = JSON.parse(playerDataEl.dataset.playerData)
  window[config.player_id] = playerData
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://steadycdn.com/podlove-subscribe-button/2024-09-09-9a9a5cd/javascripts/app.js'
  script.classList.add('podlove-subscribe-button')
  script.dataset.language = config.language
  script.dataset.size = 'big'
  script.dataset.hide = 'true'
  script.dataset.color = '#FF7264'
  script.dataset.buttonid = config.player_id
  script.dataset.jsonData = config.player_id

  document.body.appendChild(script)
})
